import React, {useState, useEffect} from 'react';
import {API_ENDPOINTS} from "../../../apiConfig";
import DeviceCategoryModal from "../../../components/DeviceCategoryModal";
import API from "../../../utils/API";
import moment from 'moment';
import {useTranslation} from 'react-i18next';
import Forms from "../../../components/Forms";
import DeleteIconButton from "../../../components/Forms/DeleteIconButton";
import EditIconButton from "../../../components/Forms/EditIconButton";
import {useModal} from "../../../contexts/ModalContext";
import AdminDataView from "../../../components/AdminDataView";

const DeviceCategories = () => {
    const [categories, setCategories] = useState([]);
    const {t} = useTranslation();
    const [error, setError] = useState();
    const {openModal, confirm} = useModal();


    const fetchCategories = async () => {
        const response = await API.get(API_ENDPOINTS.device.listCategories);
        setCategories(response.data);
    };

    useEffect(() => {
        fetchCategories();
    }, []);

    const columns = [
        {
            key: 'name',
            name: t('name'),
            renderCell: ({row}) => row.name
        },
        // {key: 'name', name: t('name')},
        {key: 'description', name: t('description')},
        {
            key: 'createdBy',
            name: t('createdBy'),
            renderCell: ({row}) => `${row.createdBy.name} ${row.createdBy.surname}`
        },
        {
            key: 'createdAt',
            name: t('createdAt'),
            renderCell: ({row}) => moment(row.createdAt).format('DD.MM.YYYY HH:mm')
        },
        {
            key: 'actions',
            name: 'Akce',
            width: 110,
            renderCell: ({row}) => (
                <div className="flex items-center justify-end h-full w-full">
                    <EditIconButton title="Upravit kategorii zařízení" onClick={() => openDeviceCategoryModal(row)}/>
                    <DeleteIconButton title="Smazat kategorii zařízení" onClick={() => confirmDeleteDeviceCategory(row)}/>
                </div>
            )
        }
    ].map(column => ({...column, resizable: true}));

    const confirmDeleteDeviceCategory =async (category) => {
        const result = await confirm(t('confirmCategoryDeletion', {category: category.name}));
        if (result === true) {
            try {
                await API.delete(API_ENDPOINTS.device.delete(category._id));
                setCategories(categories.filter(c => c._id !== category._id));
            } catch (error) {
                setError(error);
                console.error("Failed to delete category:", error);
            }
        }
    };

    const openDeviceCategoryModal = (category) => {
        openModal(DeviceCategoryModal, {
            category,
            onCategoryAdded: fetchCategories
        })
    }

    return (
        <div>
            <Forms.Button label={t('addCategory')} onClick={openDeviceCategoryModal} className="mb-8"/>
            <AdminDataView section="device-categories" rows={categories} columns={columns}/>
        </div>
    );
};

export default DeviceCategories;
